module.exports = __webpack_public_path__ + "img/logo2.e7634e66.png";